import { Col, Row } from 'antd';
import i18next, { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { LoanApplicationDto } from 'src/generated-api-client';

type LoanApplicationInitialOfferProps = {
    application?: LoanApplicationDto;
};

export const LoanApplicationInitialOffer = observer(
    ({ application }: LoanApplicationInitialOfferProps) => {
        return (
            <Card title={t('LoanApplication.InitialOffer.Title')}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.InitialOffer.OfferName')}
                            value={application?.initialOffer?.name}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.InitialOffer.Conditions')}
                            value={getOfferCardCondition(
                                application?.initialOffer,
                            )}
                            formatValue="textPreWrap"
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);

const getOfferCardCondition = (offer: LoanApplicationDto['initialOffer']) => {
    if (i18next.language === 'ar' && offer?.cardArabic) {
        return offer?.cardArabic;
    }

    return offer?.cardEnglish;
};
